module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.39.1.0.box.651.1172.413.152.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.39.1.0.box.704.1172.308.47.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chapter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Three ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.39.1.1.box.651.1294.413.30.q.80"
    }
  }, [_vm._v("GOING TO PIECES")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.2.0.box.261.1387.1201.870.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.2.0.box.261.1387.1200.400.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.1.0"
    }
  }), _vm._v("In ")]), _vm._v("Louisiana one often hears the remark that such and such a family has \"gone to pieces.\" As a child I used to picture that dire calamity in my mind. Did the men and women explode, I wondered—heads going in one direction, arms and legs in another? Or did they drop to pieces languidly, leaving a finger here and a toe there? Both pictures were depressing enough.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.2.1.box.262.1799.1200.458.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.2.0"
    }
  }), _vm._v("Later, I learned what people meant when they said such things, but for some unexplained reason the phrase still brings to my mind the idea of bodily disintegration. In the thirty years that my memory covers, I can remember several families which went that way. And of all such families, our old friends the Meadowses were most characteristic. I shall tell you their story, not because it is important, but because it is typical. They began with everything and ended"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.40.1.0.box.262.447.1200.166.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v("\nwith nothing. It was all pathetic and, at the same time, ridiculous—a humorous tragedy without even death to give it dignity.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.261.447.1202.1822.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.262.627.1201.990.q.60"
    }
  }, [_vm._v("The family came from Virginia, or rather the family of Tim Meadows lived there. \"Wild Tim,\" as he was called, married his first cousin, a girl from a Louisiana plantation. She was the last of her family and was very poor, and her marriage was considered an excellent thing for her. Every one spoke of it, thirty-five years ago when the ceremony took place, and they were still talking of it six or seven years later, when I first remember them. People said what a lucky girl Fanny had been, to marry into a family so outrageously rich. For the Meadows family had an estate at Saratoga Springs, a town house in Richmond, and a yacht and a cottage at Norfolk. There was a small plantation in Louisiana that Wild Tim had inherited from a great uncle. The Louisiana property was hardly worth mentioning when compared to the grandeur of the other places. Nevertheless it was something. In addition to all this, Tim's father had nearly two million dollars in stocks and bonds.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.262.1631.1200.341.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.2.0"
    }
  }), _vm._v("The wedding must have been grand enough to satisfy even the envious ones, and everybody congratulated Fanny and talked about her as though she were Cinderella. She went away with Tim and letters came back telling of her good times on the yacht and at Saratoga, and of how they rode to hounds in Virginia. This went on for fifteen years.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.3.box.261.1985.1200.284.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.3.0"
    }
  }), _vm._v("Then Tim's father died and the property was divided equally between him and his sister. The sister lost no time in marrying an Italian nobleman and going to live in Rome. She turned all of her inheritance into cash and brought it with her to Italy, where her count invested it. Unlike many"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.262.441.1198.106.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("\ninternational marriages, hers was happy. The Count was a good business man and her investments prospered.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.1.0.box.262.441.1205.1815.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.262.560.1200.635.q.60"
    }
  }, [_vm._v("But Wild Tim, now possessed of nearly a million dollars in cash and much valuable property, determined to become a financier. Or, at least, that is probably the way he thought about it. Heretofore he had been a jolly, good-natured, hospitable, hard-drinking young man, who entertained in Virginia and who came to Louisiana to his wife's old home at Christmas time, driving in a magnificent carriage with his wife and small daughter, just so every one could see what a lucky girl Fanny was. That is the way I remember him, driving about, making calls on New Year's Day. The little girl was just my age.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.264.1210.1201.632.q.60"
    }
  }, [_vm._v("Every one said that Wild Tim was the best company in the world; they said he was amusing, he was entertaining, and so on. All in all, a good fellow. I suppose that he really was amusing and entertaining, although great wealth has a tendency to make men appear cleverer than they are, and in our part of the world there were few indeed who were so rich. At any rate, Tim was an excellent host. Everybody conceded that. His Christmas parties were famous in Louisiana. He always served champagne. I was too young to have any, unfortunately, and when I grew old enough to indulge in it, Wild Tim had stopped giving parties.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.3.box.267.1855.1200.401.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _vm._v("Since he had everything he wanted out of life, it was impossible for him to believe that he should not always have everything. His was one of those sanguine temperaments; he believed in himself implicitly. One Christmas, shortly after the fortune had been divided, he left his wife in Louisiana and went to New York to take a little look at Wall Street. In six months he was back in Louisiana again,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.0.box.264.445.1201.877.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _vm._v("\nwithout a penny. He was never able to account for the money he lost, and I do not remember that he even tried to account for it. It was gone, but there was no need to worry. That was what he told his wife, at least, and she repeated it about the neighborhood, although she did seem a little vexed, as I remember. They would sell their property, and the yacht, she said, and another fortune would be theirs. So Tim sold the Richmond house and the yacht and the house at Saratoga Springs. To his surprise the forced sale did not bring anything like the amount that he anticipated. When fees were paid and the money was in hand, it was a mere fifty thousand dollars. A bagatelle. A man couldn't live on that, he said, not Wild Tim Meadows, anyway. So he went back to Wall Street again, and the fifty thousand dollars followed after the million.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.262.445.1203.1817.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.1.box.262.1334.1201.808.q.60"
    }
  }, [_vm._v("His wife, being an old-fashioned lady of the oldfashioned South, left the entire business management to her husband, but she was shocked and surprised to hear of the second misadventure. It dawned upon her, probably, that her days of luxury were numbered. There was still a piece of property in Florida or somewhere, and she prevailed upon him to sell that and to invest the money—it was ten or fifteen thousand dollars—in the small Louisiana plantation. He had retained the Louisiana property only because he could not sell it for any price, and it was his wife's idea that the plantation, with careful management, would support them. Then, too, she would be among her old friends and it would not matter if the family lived simply. She had done it before and she could do it again.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.2.box.263.2156.1199.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _vm._v("So Wild Tim settled among us and gave his attention to the few hundred acres of rolling land suitable for grow"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.43.1.0.box.261.439.1202.510.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _vm._v("ing cotton. He knew nothing whatever about farming, but with characteristic assurance he said that the life of a planter was just the life for him, and he began to discuss his ancestral acres as though the planting of cotton was a thing in which he excelled. But the money disappeared so rapidly chat he found himself with only a huge red barn to show for his efforts, and there was no money to build a dwelling or buy even a few mules and farming implements. A pretty mess indeed.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.1.0.box.261.439.1202.1809.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.1.box.261.972.1201.1041.q.60"
    }
  }, [_vm._v("There was only one thing to do, so he did it. He wrote to the countess and asked her for a loan. She was surprised, but she was willing to help a little. The count objected, or so she wrote, but she did send five thousand dollars, intimating, I am afraid, that it was all that she would lend, and advising Wild Tim to make the best of it. But the five thousand dollars disappeared before the house was half completed. And it was never completed. It was unfinished inside, with rough walls and floors, but it would do until he arranged for something better, he said. Into this cabin they moved the fine furniture from the Richmond house, or as much as the dwelling would hold. There were fine rugs on the floors, and the rough board walls were covered with old sporting prints and engravings. The hall was hung solidly with family portraits—magnificent old paintings of dead and gone aristocrats, who stared before them with cold eyes, as though they thought they had come down in the world, which they had indeed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.2.box.263.2027.1200.221.q.60"
    }
  }, [_vm._v("Mrs. Meadows was expecting another baby. In fact, it was born shortly after they moved into the new house. Wild Tim, feeling that it was necessary to make at least one grand gesture in his wife's community, went into town and ordered"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.0.box.262.445.1199.520.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _vm._v("\nall of the champagne that was to be had from the local dealer in wines and liquors. He invited the whole countryside to attend the christening and to drink champagne. All the plantation people from the surrounding country, as well as many families from town, went to the Meadows house that night to drink champagne in honor of the new-born son. The fact that Tim never had enough money to pay for the champagne destroyed his credit, and to this day the family must pay cash for all they buy—which isn't much.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.1.0.box.262.445.1203.1818.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.1.box.262.978.1203.1163.q.60"
    }
  }, [_vm._v("The daughter was about fifteen years old when the second child, a boy, was born, and she had received the rudiments of education. Her governess had taught her to chatter in French, she could play badly upon the piano, and she had the other usual accomplishments considered necessary to a young lady of fortune. But, alas and alack, her schooling stopped now, for Wild Tim was reduced to real poverty. He was not able to get straight with the world again. This was twenty years ago, and he has never been able to get straight. He did try various schemes, and a second loan from the reluctant countess gave him enough money to start a chicken farm. But instead of beginning in a small way, he bought elaborate incubators and brooders which he could never learn to manipulate. In six months the money was all gone, and the chickens too. Another time he borrowed enough from some old friends to start a career as a florist. Florists made lots of money, he said; I remember hearing him tell my grandfather all about it. But he never had enough money to begin properly, and the only year that the flowers were doing well, a sudden frost killed them all.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.2.box.265.2155.1200.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0"
    }
  }), _vm._v("His daughter spent her time in visiting former friends who were rich enough to entertain a young lady of her"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.1.0.box.261.441.1204.1812.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("\nstation in a proper manner. They welcomed this charming girl into their homes, but she was like her father—impractical, stubborn, and incapable of economy. When she had visited every one that it was possible to visit and when all of her fine clothes were worn out, she was forced to come home again. Her one chance of escape was disappearing, for she was now nineteen and there was no suitor in sight. The fine matches which would have been possible for her in former years were out of the question now, and there could be no thought of the fashionable Miss Meadows marrying one of the town boys, the son of some ordinary merchant or small farmer. And so Fannye—she was named for her mother, but she had added another letter to her name— became twenty-one, and then twenty-two. In the meantime the son was growing up without any education at all. The house was remote; they had no horses or carriages, and in those days the sons of plantation-owners did not attend the public schools in Louisiana. There were good private schools, but the Meadows family could never afford one. His mother seemed incapable of teaching him anything, his father was now too irascible, and Fannye went about bathed in tears. It was odd, but in losing his money Wild Tim lost his happy, good-natured disposition. Life for the Meadows family became cruel. The time came when they were without the necessities of life. And always their blind senselessness kept them from getting anywhere. Everything that Tim Meadows touched seemed to fail, and he became crabbed and quarreled with every one. He would spend his entire time in talking of the good old days and of foxhunting in Virginia, while his wife sewed for neighbors and did the odd jobs that she could get.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.1.0.box.261.441.1204.1812.q.60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.1.0.box.262.447.1202.1818.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.0.box.262.447.1199.520.q.60"
    }
  }, [_vm._v("When Fannye was twenty-five she left home and went to look for work in New Orleans, but she was too much like her father to be a success at anything. She was untrained, and she had never been able to add or subtract. Her jobs were always of the type in which money was handled— either clerking in a store or working as cashier—and she managed to lose each job before a week was out. She was easily confused and would cry if accused of making a mistake, and her carelessness got her into endless scrapes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.1.box.262.980.1202.812.q.60"
    }
  }, [_vm._v("She was rather pretty, with soft yellow hair and large, limpid blue eyes, and if a man accosted her in the street and said, \"Haven't I met you before somewhere?\" she would think that perhaps he really had met her, and would stop and argue about it, trying to remember who he was. The man usually convinced her that he was an old friend. It seemed incredible to her that any man she met in the street should treat her otherwise than as a perfect gentleman should treat a lady. Her life in New Orleans consisted of getting jobs and losing them, of meeting men and making engagements with them. Later she sprang screaming from taxi-cabs, when they attempted liberties. She never learned anything at all from experience. She was like her father in that, too.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.2.box.264.1809.1200.456.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.2.0"
    }
  }), _vm._v("Her trips to New Orleans always ended in the same way. She would return crushed and broken to the country, where she remained in misery, and made her family miserable, too. Like her father, she was always inventing magnificent schemes to make money, schemes which always came to nothing. One month she determined to study interior decorating, and the next she decided to give up interior decorating for the life of a book agent. The month after that she"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.47.1.0.box.261.441.1199.341.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  }), _vm._v("\nwas sure that fame and fortune awaited her on the stage. But as she could never secure a job with an interior decorator, nor an interview with a theatrical manager, and as she found it impossible to memorize the sales talk for selling books, all these plans came to nothing in the end. And so it went on, from year to year.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.1.0.box.261.441.1205.1819.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.1.box.262.796.1200.273.q.60"
    }
  }, [_vm._v("Each season the Meadows family was a little poorer, if possible. The diamonds had been sold long since; an antique dealer had bought the old furniture. The sporting prints had disappeared from the walls. At last, even the family portraits went.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.2.box.263.1092.1201.576.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.2.0"
    }
  }), _vm._v("I used to go and see the family sometimes, for I was one of the few people who "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("were ")]), _vm._v("still willing to listen to tales of fox-hunting in Virginia. And Fannye's frank confessions amused me. I would listen by the hour while she told of the pitfalls which awaited good girls in the wicked city, and I would urge her to try her luck again, not that I thought she had even a remote chance for success, but because I thought starvation in the city was preferable to suicide at home. And she was always threatening suicide, which made her brother laugh, her mother cry, and her father curse.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.3.box.264.1682.1202.578.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.3.0"
    }
  }), _vm._v("The last time I went to their house I witnessed a tragedy. Old Tim Meadows—he is truly old now—had read an advertisement in a magazine. The advertisement pertained to a miraculous knitting machine. "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("\"buy ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Our ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mar")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Velous ")]), _vm._v("Knitting Machine "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("For ")]), _vm._v("$75 "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Become ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("In")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Dependent ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("For ")]), _vm._v("Life. "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("We ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Furn1sh ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Yarn ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Buy ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("All ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Socks ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("That ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Kn1t, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("At ")]), _vm._v("$3 "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A ")]), _vm._v("Pair. A "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sk1lful ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Kn1tter ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Can ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Earn ")]), _vm._v("$9 "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Day ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("At ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Home ")]), _vm._v("in "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("H1s ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Spare ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("T1me. ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Why ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Not ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("You?\" ")]), _vm._v("It was something like that. It is characteristic of the Meadows family that they believe any"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.48.1.0.box.206.448.1197.284.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _vm._v("thing that they see in print. Old Mr. Meadows wrote to a friend that he had not seen in thirty years, and asked for the loan of seventy-five dollars, sending his personal note for sixty days, and writing somewhat mysteriously that he was going into a lucrative business.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.1.0.box.205.448.1201.1813.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.1.box.205.744.1199.461.q.60"
    }
  }, [_vm._v("His wife and daughter begged and pleaded with him not to throw the money away, but he was quite sure of his future. His fortune would be built up again by means of the knitting machine. In his mind he saw himself making money, buying other machines, hiring negro labor for a dollar a day to operate hundreds of similar machines. There was no end to it. He explained it all, carefully, and then explained it over again, asking for my support and agreement.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.2.box.206.1218.1200.566.q.60"
    }
  }, [_vm._v("As I have said, I was at the Meadowses' house the day the knitting machine arrived. It was a complicated device with shuttles and spools and many clicking wheels. I saw the old man take it out of the crate, while his wife and daughter wept in each other's arms by the back door. He chuckled and cursed by turns as he assembled the machine, but an hour later the chuckles and curses had ceased and he came, rather shamefacedly, to say that he was unable to manipulate the damned thing, and would his wife please come and see what she could do?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.3.box.205.1808.1201.453.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.3.0"
    }
  }), _vm._v("She came, and she succeeded in knitting one very curious looking sock; it was all out of shape, and the heel was really no heel at all; but old Tim Meadows was jubilant. He began one of his own, amid many expletives. But the thread broke, the shuttles caught, and the wheels refused to turn. In another hour the machine was a twisted mass of torn worsted and broken wheels. It ended when the old man flew into a rage and kicked the machine down the front"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.49.1.0.box.263.442.1198.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _vm._v("\nsteps to complete destruction on the brick-paved walk, while wife and daughter wailed afresh over the money it represented.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.1.0.box.263.442.1198.340.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.1.box.264.619.1197.163.q.60"
    }
  }, [_vm._v("The last thing that I heard about the Meadows family was that a lawyer had entered suit against the old gentleman for a seventy-five dollar promissory note.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.50.0.0.box.257.332.1205.746.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-930d42f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0018.vue
// module id = 69
// module chunks = 0